import { query_service_detail_list } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
} from '@/components/page-model/mjstore/mjstore-servicedetail-config';

import { reactive } from 'vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import modalBox from '@/components/form-modal/modal-tools';
import { getDateTime } from '@/utils/function';

export default () => {
  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY);
  const None = null;
  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
      col: [],
    },
    fields: [
      {
        type: 'remotemodal',
        name: 'customer_id',
        label: '会员姓名',
        disabled: false,
        placeholder: '请选择会员姓名',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-customer',
      },
      {
        type: 'remoteselect',
        name: 'shop_id',
        label: '执行门店',
        disabled: !!current_shop,
        placeholder: '请选择执行门店',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-shop',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      customer_id: null,
      shop_id: current_shop?.id,
    }),
  };
  const search_options = {};

  const edit_model_config: SearchConfig = {
    settings: {},
    fields: [],
    rules: {},
    model: reactive({}),
  };
  const edit_model_config_options = {};

  const update_model_config: SearchConfig = {
    settings: {},
    fields: [],
    rules: {},
    model: reactive({}),
  };
  const update_model_config_options = {};

  const titleList = {
    title: '服务过程',
    addModalTitle: '新建服务过程',
    updateTitle: '修改服务过程',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {};

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
      fixed: 'left',
    },
    {
      title: '会员编号',
      width: 150,
      dataIndex: 'customer__code',
      checked: true,
    },
    {
      title: '会员姓名',
      width: 150,
      dataIndex: 'customer__name',
      checked: true,
    },
    {
      title: '耗单日期',
      width: 150,
      dataIndex: 'order_used_record__date',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '耗单号',
      width: 170,
      dataIndex: 'order_used_record__order_code',
      checked: true,
    },
    {
      title: '项目名称',
      width: 80,
      dataIndex: 'order_used_record__project__name',
      checked: true,
    },
    {
      title: '项目次数',
      width: 80,
      dataIndex: 'order_used_record__num',
      checked: true,
    },
    {
      title: '效果图',
      width: 170,
      dataIndex: 'image_list',
      slots: { customRender: 'image_list' },
      checked: true,
    },
    {
      title: '注意事项',
      width: 120,
      dataIndex: 'note',
      checked: true,
    },
    {
      title: '服务执行门店',
      width: 120,
      dataIndex: 'order_used_record__shop__name',
      checked: true,
    },
    {
      title: '服务执行人',
      width: 100,
      dataIndex: 'order_used_record__staff__name',
      checked: true,
    },
    {
      title: '服务记录/诊断记录',
      width: 180,
      dataIndex: 'service_note',
      checked: true,
    },
    {
      title: '回访记录',
      width: 260,
      dataIndex: 'customer_feedback',
      checked: true,
    },
    {
      title: '记录执行门店',
      width: 120,
      dataIndex: 'shop__name',
      checked: true,
    },
    {
      title: '记录执行人',
      width: 120,
      dataIndex: 'staff__name',
      checked: true,
    },
    {
      title: '记录日期',
      width: 150,
      dataIndex: 'date',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '操作',
      dataIndex: 'action',
      checked: true,
      width: 120,
      cellComponent: 'action',
      fixed: 'right',
    },
  ];
  const newSlotList: any = [];
  Object.assign(newSlotList, slotList);

  newSlotList.push({
    type: 'click',
    slotName: 'image_list',
    content: (record: any) => {
      if (record.before_image_json.length == 0 && record.after_image_json.length == 0) {
        return '未上传图片';
      }
      return (
        '服务前' +
        record.before_image_json.length +
        '张；' +
        '服务后' +
        record.after_image_json.length +
        '张'
      );
    },
    cb: (record: any) => {
      console.log('record', record);
      const editModal = reactive({
        visible: true,
        before_image_list: record.before_image_json,
        after_image_list: record.after_image_json,
        component: 'double-image-info-modal',
        ok: () => {},
      });
      modalBox(editModal);
    },
  });
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_service_detail_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
